import * as React from 'react';
import { NotificationI } from '../../../types';
import { observer } from 'mobx-react';


interface NotificationHtmlPropsI {
  message: NotificationI,
}


export const NotificationHtml = observer((props: NotificationHtmlPropsI) => {
  const {message} = props;
  return( <div className={'notification_item'}  dangerouslySetInnerHTML={{__html: message.message }}>
  </div>
  );
});
